import React from "react";
import { Box, Typography, Container } from "@mui/material";
import DymoLabelPrinter from "../components/EldanPrinter/DymoLabelPrinter";
import { useUser } from "../contexts/UserContext";

const EldanPrinterPage = () => {
  const { user } = useUser();

  // Check if user has permission to access this page
  if (!user?.roles?.some((role) => role.EldanPrinterPage || role.admin)) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="60vh"
        >
          <Typography variant="h5" color="error" gutterBottom>
            אין לך הרשאה לגשת לעמוד זה
          </Typography>
          <Typography variant="body1" color="textSecondary">
            פנה למנהל המערכת להקצאת הרשאות מתאימות
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg">
      {/* Elegant Header */}
      <Box textAlign="center">
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 700,
            color: "#333",
            mb: 1,
            direction: "rtl",
            fontSize: { xs: "2rem", md: "2.5rem" },
          }}
        >
          🏷️ מדפסת תוויות DYMO
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: "#666",
            fontStyle: "italic",
            direction: "rtl",
          }}
        >
          הדפסת תוויות עם מידע מכשירים מהמערכת
        </Typography>
      </Box>

      <DymoLabelPrinter user={user} />
    </Container>
  );
};

export default EldanPrinterPage;
